export default __webpack_public_path__ + "static/media/logo.7fdbf42a.png";